import { MappingTipiEntitaPratica } from '../../../common/configuration/mapping-tipi-entita-pratica';
import { ServicePathsSettings as sp } from '../../../core/configuration/service-paths-settings';
import { UrlSettingsCore } from '../../../core/configuration/url-settings-core';

export class OperationsUrlSettingsFascicolo {

  // variabili specifiche per il fascicolo
  public static readonly TIPO_PRATICA: string = '/' + sp.NOME_BE_PRATICA_AMMINISTRATIVA; // nome della pratica data dal BE
  public static readonly ID_TIPO_PRATICA: any = MappingTipiEntitaPratica.PRATICA_AMMINISTRATIVA;
  public static readonly MODULO_FASCICOLO: string = UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_AMMINISTRATIVA;
  public static readonly URL_MODULO_FASCICOLO_INS = UrlSettingsCore.URL_INSERIMENTO_FASCICOLO_AMMINISTRATIVA;
  public static readonly URL_MODULO_FASCICOLO_CREATE = UrlSettingsCore.URL_MODULO_FASCICOLO_GENERIC_AMMINISTRATIVA_CREATE;
  public static NAME_FOR_HTML(genericFascicolo) {
    return genericFascicolo.charAt(0).toUpperCase() + genericFascicolo.slice(1);
  }
  // fine

  public static readonly PATH_FASCICOLO: string = sp.OPERATIONS_PATH + sp.GESTIONE_PRATICHE_PATH +
                                                    OperationsUrlSettingsFascicolo.TIPO_PRATICA + '/fasc/'; /* +
                                                    OperationsUrlSettingsFascicolo.TIPO_FASCICOLO;*/

  // GET
  public static URL_GET_FASCICOLO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo;
  }
  public static readonly URL_GET_SEZIONE_DATI_CLASSIFICAZIONE: string = '';
  public static URL_GET_SEZIONE_CONTROPARTI(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/controparti';
  }
  public static URL_GET_SEZIONE_PATOLOGIE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/patologie';
  }
  public static URL_GET_SEZIONE_SCHEDE_RECUPERO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/schederecupero';
  }
  public static URL_GET_SEZIONE_SCHEDE_ESECUZIONE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/schedeesecuzione';
  }
  public static URL_GET_SEZIONE_DATI_PIGNORAMENTO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/datipignoramento';
  }
  public static URL_GET_SEZIONE_PROVE_SCRITTE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/provescritte';
  }
  public static URL_GET_SEZIONE_PAGAMENTI(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/pagamenti';
  }
  public static URL_GET_SEZIONE_INCASSI(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/incassi';
  }
  public static URL_GET_SEZIONE_SCADENZARIO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/scadenze';
  }
  public static URL_GET_SEZIONE_DOCUMENTAZIONE_ALLEGATA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/documentazione';
  }
  public static URL_GET_SEZIONE_LEGALI(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/legali';
  }
  public static URL_GET_SEZIONE_ALTRE_PARTI(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/altreparti';
  }
  public static URL_GET_SEZIONE_ESITI(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/esiti';
  }
  public static URL_GET_SEZIONE_ECONOMICA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/economici';
  }
  public static URL_GET_SEZIONE_ATTI(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/atti';
  }
  public static URL_GET_SEZIONE_FATTURE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/fatture';
  }
  public static URL_GET_SEZIONE_PARCELLE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/parcelle';
  }
  public static URL_GET_SEZIONE_PARCELLE_STRAGIUDIZIALI(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/parcelle';
  }
  public static URL_SCAGLIONI_PARCELLA_BY_FASCICOLO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/parcelle/competenzaparcella/{idCompetenzaParcella}/scaglioni';
  }
  public static URL_GET_SEZIONE_LETTERE_DIFFIDA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/letterediffida';
  }
  public static URL_GET_SEZIONE_BANCHE_DATI(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/banchedati';
  }

  // PUT
  public static URL_UPDATE_ASSOCIAZIONE_CONTROPARTE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/controparti/{idSezione}/controparte ';
  }
  public static URL_UPDATE_PATOLOGIA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/patologie/{idSezione}/patologie ';
  }
  public static URL_UPDATE_SCHEDA_RECUPERO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/schederecupero/{idSezione}/schede ';
  }
  public static URL_UPDATE_SCHEDA_ESECUZIONE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/schedeesecuzione/{idSezione}/schede ';
  }
  public static URL_UPDATE_ASSOCIAZIONE_LEGALE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/legali/{idSezione}/legaleincaricato';
  }
  public static URL_UPDATE_ESITO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/esiti/{idSezione}/esito';
  }
  public static URL_UPDATE_SCADENZA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/scadenze/{idSezione}/scadenza';
  }
  public static URL_UPDATE_DATI_GENERALI(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/';
  }
  public static URL_UPDATE_ASSOCIATIVA_ALTRAPARTE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/altreparti/{idSezione}/altraparte';
  }
  public static URL_UPDATE_ANAGRAFICA_LEGALE(genericFascicolo): string {
    return sp.OPERATIONS_PATH + sp.GESTIONE_PRATICHE_PATH + '/legale/';
  }
  public static URL_UPDATE_ANAGRAFICA_PARTE(genericFascicolo): string {
    return sp.OPERATIONS_PATH + sp.GESTIONE_PRATICHE_PATH + '/parte';
  }
  public static URL_UPDATE_SET_AS_PRIMARIA_CONTROPARTE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/controparti/{idSezione}/controparte/{idControparte}/primaria';
  }
  public static URL_UPDATE_SET_AS_PRIMARIO_LEGALE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/legali/{idSezione}/legaleincaricato/{idLegaleIncaricato}/principale';
  }
  public static URL_UPDATE_DISATTIVA_LEGALE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/legali/{idSezione}/legaleIncaricato/{idLegaleIncaricato}/ritirato';
  }
  public static URL_UPDATE_DISATTIVA_CONTROPARTE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/controparti/{idSezione}/controparte/{idControparte}/ritirato';
  }
  public static URL_UPDATE_DISATTIVA_ALTRA_PARTE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/altreparti/{idSezione}/altraparte/{idAltraParte}/ritirato';
  }
  public static URL_UPDATE_LEGALE_INCARICATO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/legali/{idSezione}/legale_incaricato';
  }
  public static URL_UPDATE_LEGALE_LEGALE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/legali/{idSezione}/legale';
  }
  public static URL_UPDATE_SCADENZE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/scadenze/{idSezione}/scadenza';
  }
  public static URL_UPDATE_ATTO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/atti/{idSezione}/atto';
  }
  public static URL_UPDATE_PAGAMENTO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/pagamenti/{idSezione}/pagamento';
  }
  public static URL_UPDATE_FATTURA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/fatture/{idSezione}/fattura';
  }
  public static URL_UPDATE_INCASSO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/incassi/{idSezione}/incasso';
  }
  public static URL_UPDATE_RIPARTIZIONE_INCASSO(genericFascicolo):string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/incassi/{idSezione}/incasso/ripartizione';
  }
  public static URL_UPDATE_RIPARTIZIONE_PARCELLA(genericFascicolo):string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/parcelle/{idSezione}/parcella/ripartizione';
  }
  public static URL_UPDATE_PARCELLA_STRAGIUDIZIALE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/parcelle/{idSezione}/parcella';
  }
  public static URL_UPDATE_SEZIONE_ECONOMICA_REVISIONE_PETITUM(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/economici/{idSezione}/petitum/revisione';
  }
  public static URL_UPDATE_SEZIONE_ECONOMICA_REVISIONE_FONDO_RISCHI(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/economici/{idSezione}/fondorischi/revisione';
  }
  public static URL_UPDATE_SEZIONE_ECONOMICA_CONTRIBUTO_UNIFICATO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/economici/{idSezione}/contributoUnificato';
  }
  public static URL_UPDATE_SEZIONE_ECONOMICA_PETITUM(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/economici/{idSezione}/petitum';
  }
  public static URL_UPDATE_SEZIONE_ECONOMICA_DATA_INIZIO_CALCOLO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/economici/{idSezione}/petitum/datainiziocalcolo';
  }
  public static URL_UPDATE_SEZIONE_ECONOMICA_FONDO_ONERE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/economici/{idSezione}/fondoonere';
  }
  public static URL_UPDATE_SEZIONE_ECONOMICA_LIQUIDATI(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/economici/{idSezione}/liquidato';
  }
  public static URL_UPDATE_EVADI_SCADENZA(genericFascicolo): string {
    return sp.OPERATIONS_PATH + genericFascicolo + sp.GESTIONE_PRATICHE_PATH + '/scadenza/{idScadenza}/evasa';
  }
  public static URL_UPDATE_LETTERA_DIFFIDA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/letterediffida/{idSezione}/letteradiffida';
  }

  // POST
  public static URL_ADD_SCADENZA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/scadenze/{idSezione}/scadenza';
  }
  public static URL_ADD_PAGAMENTO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/pagamenti/{idSezione}/pagamento';
  }
  public static URL_ADD_FATTURA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/fatture/{idSezione}/fattura';
  }
  public static URL_ADD_INCASSO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/incassi/{idSezione}/incasso';
  }
  public static URL_ADD_PARCELLA_STRAGIUDIZIALE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/parcelle/{idSezione}/parcella';
  }
  public static URL_ADD_IN_ANAGRAFICA(genericFascicolo): string {
    return sp.OPERATIONS_PATH + genericFascicolo + sp.GESTIONE_PRATICHE_PATH + '/parte';
  }
  public static URL_ADD_RIPARTIZIONE_INCASSO(genericFascicolo):string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/incassi/{idSezione}/incasso/ripartizione';
  }
  public static URL_ADD_RIPARTIZIONE_PARCELLA(genericFascicolo):string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/parcelle/{idSezione}/parcella/ripartizione';
  }
  public static URL_ADD_CONTROPARTE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/controparti/{idSezione}/controparte';
  }
  public static URL_ADD_PATOLOGIA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/patologie/{idSezione}/patologia';
  }
  public static URL_ADD_SCHEDA_RECUPERO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/schederecupero/{idSezione}/scheda';
  }
  public static URL_ADD_SCHEDA_ESECUZIONE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/schedeesecuzione/{idSezione}/scheda';
  }
  public static URL_ADD_ALTRA_PARTE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/altreparti/{idSezione}/altraparte';
  }
  public static readonly URL_ADD_ANAGRAFICA_LEGALE: string = sp.OPERATIONS_PATH + sp.GESTIONE_PRATICHE_PATH + '/legale';

  public static URL_ADD_LEGALE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/legali/{idSezione}/legaleIncaricato';
  }
  public static URL_ADD_ATTO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/atti/{idSezione}/atto ';
  }
  public static URL_ADD_SEZIONE_ECONOMICA_REVISIONE_PETITUM(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/economici/{idSezione}/petitum/revisione';
  }
  public static URL_ADD_SEZIONE_ECONOMICA_REVISIONE_FONDO_RISCHI(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/economici/{idSezione}/fondorischi/revisione';
  }
  public static URL_ADD_SEZIONE_ECONOMICA_CONTRIBUTO_UNIFICATO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/economici/{idSezione}/contributoUnificato';
  }

  public static URL_ADD_SEZIONE_ECONOMICA_PETITUM(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/economici/{idSezione}/petitum';
  }
  public static URL_ADD_SEZIONE_ECONOMICA_FONDO_RISCHI(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/economici/{idSezione}/fondorischi';
  }
  public static URL_ADD_SEZIONE_ECONOMICA_FONDO_ONERE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/economici/{idSezione}/fondoonere';
  }
  public static URL_ADD_SEZIONE_ECONOMICA_LIQUIDATI(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/economici/{idSezione}/liquidato';
  }

  public static URL_ADD_ESITO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/esiti/{idSezione}/esito';
  }
  public static URL_ADD_DOCUMENTO_TO_DOCUMENTAZIONE_ALLEGATA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/documentazione/{idSezione}/documento';
  }
  public static URL_ADD_LETTERA_DIFFIDA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}/sez/letterediffida/{idSezione}/letteradiffida';
  }

  // DELETE
  public static URL_REMOVE_DOCUMENTO_TO_DOCUMENTAZIONE_ALLEGATA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/documentazione/{idSezione}/documento';
  }
  public static URL_DELETE_RIPARTIZIONE_INCASSO(genericFascicolo):string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/incassi/{idSezione}/incasso/{idIncasso}/{idIncassoSoggetto}';
  }
  public static URL_DELETE_RIPARTIZIONE_PARCELLA(genericFascicolo):string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/parcelle/{idSezione}/parcella/{idParcella}/{idParcellaSoggetto}';
  }
  public static URL_REMOVE_SCADENZA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/scadenze/{idSezione}/scadenza/{idScadenza} ';
  }
  public static URL_REMOVE_PAGAMENTO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/pagamenti/{idSezione}/pagamento/{idPagamento}';
  }
  public static URL_REMOVE_FATTURA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/fatture/{idSezione}/fattura/{idFattura}';
  }
  public static URL_REMOVE_SCHEDA_RECUPERO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/schederecupero/{idSezione}/scheda/{idSchedaRecupero} ';
  }
  public static URL_REMOVE_SCHEDA_ESECUZIONE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/schedeesecuzione/{idSezione}/scheda/{idSchedaEsecuzione} ';
  }
  public static URL_REMOVE_INCASSO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/incassi/{idSezione}/incasso/{idIncasso}';
  }
  public static URL_REMOVE_PARCELLA_STRAGIUDIZIALE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/parcelle/{idSezione}/parcella/{idParcellaStragiudiziale}';
  }
  public static URL_REMOVE_ATTO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/atti/{idSezione}/atto/{idAtto} ';
  }
  public static URL_REMOVE_SEZIONE_ECONOMICA_FONDO_ONERI(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/economici/{idSezione}/fondoonere/{idFondoOnere}';
  }
  public static URL_REMOVE_CONTROPARTE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/controparti/{idSezione}/controparte/{idControparte} ';
  }
  public static URL_REMOVE_PATOLOGIA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/patologie/{idSezione}/patologia/{idPatologia} ';
  }
  public static URL_REMOVE_LEGALEINCARICATO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/legali/{idSezione}/legaleIncaricato/{idLegaleIncaricato}';
  }
  public static URL_REMOVE_ESITO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/esiti/{idSezione}/esito/{idEsito}';
  }
  public static URL_REMOVE_ALTRA_PARTE(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/altreparti/{idSezione}/altraparte/{idAltraParte}';
  }
  public static URL_REMOVE_FASCICOLO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/{idFascicolo}';
  }
  public static URL_DEFINISCI_FASCICOLO(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/definizione';
  }
  public static URL_REMOVE_LETTERA_DIFFIDA(genericFascicolo): string {
    return OperationsUrlSettingsFascicolo.PATH_FASCICOLO + genericFascicolo + '/sez/letterediffida/{idSezione}/letteradiffida/{idLetteraDiffida}';
  }


  /*public static getIdFromLabelFascicolo(value) {
    const objTemp = FrontEndMapping.tipiFascicolo;
    // debugger;
    return Number(Object.keys(objTemp).find(key => objTemp[key] === value));
  }*/
}
